import { api } from "@/lib/apiClient";

export class AdminActionCancelled extends Error {
  constructor() {
    super("cancelled");
    this.name = "AdminActionCancelled";
  }
}

function confirmTwice(first: string, second: string): boolean {
  return window.confirm(first) && window.confirm(second);
}

function cancelled(): never {
  throw new AdminActionCancelled();
}

export async function publishProduction(): Promise<string> {
  const first =
    "Den aktuellen Dev-Stand auf Production (app.) veröffentlichen? " +
    "Dabei werden campdesk-api und campdesk-frontend von dev nach main promotet. " +
    "Die Production-API wird neu deployed und Datenbank-Migrationen auf campdesk_db angewendet.";
  const second =
    "Letzte Bestätigung: Production-Veröffentlichung jetzt starten? " +
    "Dies betrifft alle Nutzer von app.";
  if (!confirmTwice(first, second)) cancelled();
  const result = await api.post<{ message: string }>("/api/v1/dev/publish-production", {});
  return result.message;
}

export async function cloneProductionData(): Promise<string> {
  const first =
    "Den aktuellen Produktionsdatenstand (Mandant default) in die Testumgebung laden? " +
    "Alle bestehenden Daten des Schulungs-Mandanten werden dabei ersetzt. " +
    "Die Produktionsdaten bleiben unverändert.";
  const second =
    "Letzte Bestätigung: Produktionsdaten jetzt in test laden? " +
    "Dies kann je nach Datenmenge einige Minuten dauern.";
  if (!confirmTwice(first, second)) cancelled();
  const result = await api.post<{ message: string }>("/api/v1/dev/clone-production-data", {
    source_slug: "default",
  });
  return result.message;
}

export async function clearTestData(): Promise<string> {
  const first =
    "Alle Fachdaten dieses Mandanten unwiderruflich löschen? " +
    "Betroffen sind Gäste, Buchungen, Rechnungen, Zahlungen, Verträge, Import-Daten und Protokolle. " +
    "Stammdaten wie Plätze, Kategorien, Artikel und Einstellungen bleiben erhalten.";
  const second =
    "Letzte Bestätigung: Alle Testdaten restlos löschen? Diese Aktion kann nicht rückgängig gemacht werden.";
  if (!confirmTwice(first, second)) cancelled();
  const result = await api.post<{ message: string }>("/api/v1/dev/clear-test-data", {});
  return result.message;
}

export async function loadDemoData(options?: {
  reset?: boolean;
  today?: string;
  confirm?: boolean;
}): Promise<string> {
  const reset = options?.reset ?? false;
  const shouldConfirm = options?.confirm ?? true;
  if (shouldConfirm && reset) {
    const first =
      "Demodaten laden und vorher alle Fachdaten dieses Mandanten löschen? " +
      "Stammdaten wie Plätze, Kategorien und Artikel bleiben erhalten.";
    const second = "Letzte Bestätigung: Fachdaten löschen und Demodaten laden?";
    if (!confirmTwice(first, second)) cancelled();
  } else if (
    shouldConfirm &&
    !window.confirm(
      "Demodaten in den aktuellen Mandanten laden? Bestehende Fachdaten bleiben erhalten. " +
        "Stichtag und die Option „Vorher löschen“ stehen unter Stammdaten → Admin.",
    )
  ) {
    cancelled();
  }
  const body: { reset: boolean; today?: string } = { reset };
  const today = options?.today?.trim();
  if (today) body.today = today;
  const result = await api.post<{ message: string }>("/api/v1/dev/seed-demo", body);
  return result.message;
}
